<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">动环设备</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="设备名称" prop="equipmentName">
            <el-input
              v-model="equipmentName"
              placeholder="请输入设备名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="区域">
            <el-select v-model="areaCode" placeholder="请选择">
              <el-option key="" label="全部" value=""></el-option>
              <el-option
                v-for="item in areaData"
                :key="item.areaCode"
                :label="item.areaName"
                :value="item.areaCode"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否在线">
            <el-select v-model="onlineStatus" placeholder="请选择">
              <el-option key="" label="全部" value=""></el-option>
              <el-option key="1" label="在线" value="1"></el-option>
              <el-option key="0" label="离线" value="0"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="" class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div
            class="zj-table-container"
          >
            <el-table
              v-loading="searching"
              element-loading-text="搜索中"
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
            <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column
                prop="equipmentName"
                label="设备名称"
              ></el-table-column>
              <el-table-column prop="areaCodeTranslated" label="区域">
              </el-table-column>
              <el-table-column prop="longitude" label="经度" width="140">
              </el-table-column>
              <el-table-column prop="latitude" label="纬度" width="140">
              </el-table-column>
              <el-table-column prop="onlineStatus" label="状态" width="140">
                <template slot-scope="scope">
                  <span v-if="scope.row.onlineStatus === '0'" style="color: red"
                    >离线</span
                  >
                  <span v-if="scope.row.onlineStatus === '1'">在线</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="160">
                <template slot-scope="scope">
                  <el-button
                    @click="handleClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >查看</el-button
                  >
                  <el-button
                    @click="editClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >编辑</el-button
                  >
                  <el-button
                    @click="deleteClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>
<script>
import { listExtEquipment, delEquipment, listEquipmentArea } from "@/api/src/equipment";

export default {
  name: "DynamicEnvEquipView",
  controller: "UI",
  action: "DynamicEnvEquipView",
  data() {
    return {
      searching: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      areaData: [],
      categoryCode: "environment",
      equipmentName: null,
      areaCode: "",
      onlineStatus: "",
    };
  },
  created() {
    this.loadAreas();
  },
  mounted() {
    this.search();
    this.logInfo.ActionName = "动环设备查询";
    this.logInfo.LogMessage = "动环设备查询";
    this.logInfo.ModuleName = "动环监测";
    this.logInfo.PageName = "动环设备管理列表";
    this.addOperationLog();
  },
  methods: {
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    search() {
      this.searching = true;
      let data = {
        categoryCode: this.categoryCode,
        name: this.equipmentName || undefined,
        areaCode: this.areaCode || undefined,
        onlineStatus: this.onlineStatus || undefined,
        page: this.currentPage,
        size: this.pageSize,
      };
      listExtEquipment(data)
        .then((r) => {
          this.searching = false;
          this.tableData = r.rows;
          this.total = r.total;
        })
        .catch((e) => {
          console.log(e);
          this.searching = false;
          this.errmsg("服务异常，请联系管理员！");
        });
    },
    loadAreas() {
      listEquipmentArea({ pageNum: 1, pageSize: 999 })
        .then((r) => {
          this.areaData = r.data || [];
        })
        .catch((e) => {
          console.log(e);
        });
    },
    clearsearch() {
      this.equipmentName = null;
      this.areaCode = "";
      this.onlineStatus = "";
      this.search();
    },
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    onCancel() {
      this.clearsearch();
    },
    editClick(index, row) {
      this.$router.push({
        path: "/plugin/dynEnvironment/UI/DynamicEnvEquipInfo",
        query: {
          id: row.id,
          type: "edit",
        },
      });
    },
    handleClick(index, row) {
      this.$router.push({
        path: "/plugin/dynEnvironment/UI/DynamicEnvEquipInfo",
        query: {
          id: row.id,
          type: "look",
        },
      });
    },
    onAdd() {
      this.$router.push({
        path: "/plugin/dynEnvironment/UI/DynamicEnvEquipInfo",
        query: {
          type: "add",
        },
      });
    },
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delEquipment({ id: row.id })
            .then((r) => {
              if (r.data.code === 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.logInfo.ActionName = "动环设备删除";
                this.logInfo.LogMessage = "动环设备删除";
                this.logInfo.ModuleName = "动环监测";
                this.logInfo.PageName = "动环设备管理列表";
                this.addOperationLog();
              } else {
                this.$message({
                  type: "error",
                  message: r.data.msg || "删除失败!",
                });
              }
              this.search();
            })
            .catch((e) => {
              console.log(e);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
  },
};
</script>
